export default __webpack_public_path__ + "static/media/expert1.b661b872.jpg";